import { Modal, Button, Form, Spinner } from "react-bootstrap";

function CommentsModal({
    show,
    onHide,
    comments,
    setComments,
    processingAction,
    onConfirm
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>Reject Withdrawal Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Reason for Rejection</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Please provide a reason for rejecting this request"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    disabled={processingAction || !comments.trim()}
                >
                    {processingAction ? (
                        <>
                            <Spinner animation="border" size="sm" className="mr-2" />
                            Processing...
                        </>
                    ) : (
                        <>Confirm Rejection</>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CommentsModal;